export default __webpack_public_path__ + "static/media/rolaomodajaecoo-j7-hero-video.dcdddb10.mp4";